// Due to the distribution of variables, the order in which these functions are called is important
// TODO: Revise the architecture to make them independent of each other

$(() => {
  HomeFilter.setSelects();
  HomeFilter.bindFilters();
  HomeFilter.bindInClassCheckbox();
  HomeFilter.bindShowInClass();
  HomeFilter.showIntroResults();
  HomeFilter.bindSubjectYearSelect();

  MainTable.initTable();

StudentDashboard.setSelects();
  StudentDashboard.setHeight();
  StudentDashboard.initStudentResults();
  StudentDashboard.bindEvents();

  ExamSummaryFilter.setSelects();
  ExamSummaryFilter.bindSubjectCurrentGroupEvents();

  Users.setSelects();
  Users.initDeleteUserModal();
  Users.bindEvents();
  Users.initUserForm();

  StudentTeachers.setSelects();
  StudentTeachers.bindEvents();

  ChartsStudents.bindExamChangeEvent();
  ChartsStudents.bindSubjectChangeEvent();
  ChartsStudents.resizeChart();

  IntroResults.setSelects();
  IntroResults.bindEvents();

  ChosenPeriods.setSelects();

  StudentTargets.bindEvents();
  StudentTargets.setSelects();

  Shared.bindEvents();

  SubjectShortcuts.setSelects();

  SubjectLinks.setSelects();

  NameLinks.setSelects();
  NameLinks.bindEvents();

  InClassResults.initForms();
  InClassResults.setSelects();
  InClassResults.bindEvents();

  Profile.bindEvents();


  UploadStudents.initForm();

  UploadStudentTeacher.initForm();
  UploadStudentTeacher.setSelects();

  UploadResults.initForm();
  UploadResults.setSelects();

  OverallTracking.initPage();
  OverallTracking.setSelects();

  UploadTeachers.initForm();

  SubjectRankings.initForm();
  SubjectRankings.bindEvents();

  TutorGroups.initForm();
  TutorGroups.setSelects();

  FitnessMarkStudentDashboard.setSelects();
  FitnessMarkDashboard.createCharts();
  FitnessMarkDashboard.setSelects();
  FitnessMarkDashboard.bindEvents();
});
